import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import LogMasuk from '../components/dashboard/LogMasuk';
import Auth from '../components/dashboard/Auth';
import { FaSpinner } from 'react-icons/fa';
import logo from '../img/logo-white.png';
import logo2 from '../img/logo-main.png';
import UserCards from '../components/UserCards';

function Dashboard() {
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(true);
  
  const logOut = () => {
    localStorage.removeItem('userEmail');
    localStorage.removeItem('token');
    window.location.reload();
  };

  return (
    <div>
      <Helmet>
        <title>Dashboard | TheInviteYou.com</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div>
        <Auth setLogin={setLogin} />
        {login ? 
          (
            <div>
              {loading && (<div className="fixed inset-0 h-screen w-full bg-white bg-opacity-80 flex flex-col items-center justify-center space-y-5">
                <FaSpinner className="text-4xl text-secondary-500 animate-spin" />
                <img src={logo2} alt="Logo" className="h-12 mb-4" />
              </div>)}
              <header className="w-full bg-neutral-50 shadow-md py-4 z-10">
                <div className="flex items-center justify-center px-6">
                  <a href="/"><img src={logo2} alt="Logo" className='h-10' /></a>
                </div>
              </header>
              <div className="md:p-24 flex items-center justify-center">
                <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-lg w-full">
                  <UserCards setLoading={setLoading} />
                  <button 
                  onClick={logOut}
                  className='mt-8 w-full text-neutral-50 px-5 py-3 rounded-lg bg-secondary-500 hover:bg-secondary-700'>
                    Log Keluar
                  </button>
                </div>
              </div>
            </div>
          ) : ( 
            <div>
              <LogMasuk />
            </div>
          )
        }
      </div>
    </div>
  );
}

export default Dashboard;
